var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"settings-workstation-types-page"}},[_c('settings-workstation-types')],1)}
var staticRenderFns = []

export { render, staticRenderFns }